/**
 * RTWO Asset & Token Engine — Null Ledger Adapter
 */

import type { AssetId, RTWOAssetLifecycleStage, RTWOAssetType } from '../domain-models';
import type { ILedgerAdapter, LedgerAdapterStatus } from './ledger-adapter-interface';

export class NullLedgerAdapter implements ILedgerAdapter {
  readonly adapterId = 'null-ledger-adapter';
  readonly adapterName = 'Null Ledger Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): LedgerAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async registerAsset(
    _assetSymbol: string,
    _assetName: string,
    _assetType: RTWOAssetType,
    _decimals: number,
    _issuerReference: string
  ) {
    return null;
  }

  async configureSupplyPolicy(
    _assetId: AssetId,
    _supplyType: string,
    _maxSupplyReference: string,
    _mintingPolicy: string,
    _burningPolicy: string
  ) {
    return null;
  }

  async configureTransferRule(_assetId: AssetId, _ruleType: string, _conditionReference: string) {
    return null;
  }

  async validateAsset(_assetId: AssetId) {
    return null;
  }

  async transitionLifecycle(_assetId: AssetId, _targetStage: RTWOAssetLifecycleStage) {
    return null;
  }

  async getRegistryRecord(_assetId: AssetId) {
    return null;
  }
}
